module.exports = __webpack_public_path__ + "static/img/logo4.ef1405f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo4.png
// module id = 59
// module chunks = 4 5 6